import { addFormFields, removeFieldsById } from "../../../utils/FormFields/RemoveFields/handleRemoveFields";
import { HideShowAllCurrentEmployeeConfig, HideShowCurrentEmployeeConfig, HideShowIsBenifitsOfYourCreditorsFieldsConfig, HideShowIsCriminalOffenceFieldsConfig, HideShowOtherQualificationFieldConfig, HideShowProfessionalInfoFieldsConfig, HideShowSupportFileFieldConfig } from "./addHideShowFields";

// import { viewIndividualMemberFormDropdownConfigs } from "./setDropdownFields";
// import { ViewIndividualMemberData } from "../data/ViewIndividualMember.Data";


/**
 * Handles changes in form fields dynamically based on specific conditions.
 *
 * @param {string} dataFieldName - The name of the field that triggered the change.
 * @param {object} updateFormData - The updated field data object containing new values.
 * @param {object} ViewIndividualMemberData - The current state and structure of the form.
 */
export const handleFieldChange = (dataFieldName, updateFormData, ViewIndividualMemberData,) => {
    switch (dataFieldName) {
        case "membershipTypeId": {
            const { membershipTypeId } = updateFormData;

            if (membershipTypeId?.label !== "Associate") {
                /**
               * @param {object} ViewIndividualMemberData - The form data object.
               * @param {Array<object>} HideShowSupportFileFieldConfig - Fields to add for file uploads.
                @param {string} "relevantDiplomasCertificatesFile" - The ID after which the fields will be added.
               */
                addFormFields(ViewIndividualMemberData, HideShowSupportFileFieldConfig, "relevantDiplomasCertificatesFile");
            } else {
                /**
               * @param {object} viewIndividualMemberForm - The form data object.
               * @param {Array<string>} ['detailedListAppRoleRespoFile'] - The IDs of fields to remove.
               */
                removeFieldsById(ViewIndividualMemberData, ['detailedListAppRoleRespoFile']);
            }
            break;

        }
        case "iscriminaloffence": {
            const { iscriminaloffence } = updateFormData;

            // Add or remove fields based on criminal offence status
            if (iscriminaloffence === "no") {
                removeFieldsById(ViewIndividualMemberData, ['criminaloffenceMoreDetails']);
            } else {
                addFormFields(ViewIndividualMemberData, HideShowIsCriminalOffenceFieldsConfig, "iscriminaloffence");
            }
            break;
        }
        case "isBenifitsOfYourCreditors": {
            const { isBenifitsOfYourCreditors } = updateFormData;

            // Add or remove fields based on creditor benefits status
            if (isBenifitsOfYourCreditors === "no") {
                removeFieldsById(ViewIndividualMemberData, ['benifitsOfYourCreditorsMoreDetails']);
            } else {
                addFormFields(ViewIndividualMemberData, HideShowIsBenifitsOfYourCreditorsFieldsConfig, "isBenifitsOfYourCreditors");
            }
            break;
        }
        case "isOtherProfessional": {
            const { isOtherProfessional } = updateFormData;

            // Add or remove fields based on other professional status
            if (isOtherProfessional) {
                addFormFields(ViewIndividualMemberData, HideShowProfessionalInfoFieldsConfig, "isOtherProfessional");
            } else {
                removeFieldsById(ViewIndividualMemberData, ['isOtherProfessionalReason']);
            }
            break;
        }
        case "currentlyEmployed": {
            const { currentlyEmployed } = updateFormData;
            if (currentlyEmployed === "no") {
                removeFieldsById(ViewIndividualMemberData, HideShowCurrentEmployeeConfig);
            }
            else {
                addFormFields(ViewIndividualMemberData, HideShowAllCurrentEmployeeConfig, "currentlyEmployed");
            }
            break;
        }
        case "highestQualificationId": {
            const { highestQualificationId } = updateFormData;

            if (highestQualificationId?.label === "Others") {
                /**
               * @param {object} ViewIndividualMemberData - The form data object.
               * @param {Array<object>} HideShowOtherQualificationFieldConfig - Fields to add for file uploads.
                @param {string} "highestQualificationId" - The ID after which the fields will be added.
               */
                addFormFields(ViewIndividualMemberData, HideShowOtherQualificationFieldConfig, "highestQualificationId");
            } else {
                /**
               * @param {object} ViewIndividualMemberData - The form data object.
               * @param {Array<string>} ['other'] - The IDs of fields to remove.
               */
                removeFieldsById(ViewIndividualMemberData, ['other']);
            }
            break;
        }
        default:
            break;
    }
}

export default handleFieldChange;

export const handleEditFieldChange = (editViewIndividualMemberFormData, allDropDownResponse, apiResponse) => {
    const updateFields = (condition, addConfig, fieldKey, removeIds = []) => {
        if (condition) {
            addFormFields(editViewIndividualMemberFormData, addConfig, fieldKey);
        } else {
            removeFieldsById(editViewIndividualMemberFormData, removeIds);
        }
    };
    updateFields(
        apiResponse?.isCurrentlyEmployed === true || false,
        HideShowCurrentEmployeeConfig,
        "currentlyEmployed",
        HideShowCurrentEmployeeConfig
    );

    // Update fields based on membershipType
    updateFields(
        apiResponse?.membershipType !== 1,
        HideShowSupportFileFieldConfig,
        "relevantDiplomasCertificatesFile",
        ['detailedListAppRoleRespoFile']
    );

    updateFields(
        !apiResponse?.isCurrentlyEmployed,
        HideShowCurrentEmployeeConfig,
        "currentlyEmployed",
        HideShowAllCurrentEmployeeConfig
    );

    // Update fields based on membershipType
    updateFields(
        apiResponse?.membershipType !== 1,
        HideShowSupportFileFieldConfig,
        "relevantDiplomasCertificatesFile",
        ['detailedListAppRoleRespoFile']
    );

    // Update fields based on isCriminalOffence
    updateFields(
        apiResponse?.isCriminalOffence,
        HideShowIsCriminalOffenceFieldsConfig,
        "iscriminaloffence",
        ['criminaloffenceMoreDetails']
    );

    // Update fields based on isAdjudgedBankrupt
    updateFields(
        apiResponse?.isAdjudgedBankrupt,
        HideShowIsBenifitsOfYourCreditorsFieldsConfig,
        "isBenifitsOfYourCreditors",
        ['benifitsOfYourCreditorsMoreDetails']
    );

    // Update fields based on isOtherProfessionalInformation
    updateFields(
        apiResponse?.isOtherProfessionalInformation,
        HideShowProfessionalInfoFieldsConfig,
        "isOtherProfessional",
        ['isOtherProfessionalReason']
    );

    // Update fields based on highestQualificationAttained
    updateFields(
        Number(apiResponse?.highestQualificationAttained) === 8,
        HideShowOtherQualificationFieldConfig,
        "highestQualificationId",
        ['other']
    );
};

